module.exports = __webpack_public_path__ + "assets/da0eff0638e11c21be19e5f43f304769.png";